module.exports = __webpack_public_path__ + "static/media/favicon.ba667818.ico";